<template lang="pug">
  .pt-2.px-4.pb-4.d-flex.justify-space-between(v-if="$vuetify.breakpoint.mobile")
    .heading-5.capitalize {{ $store.state.ui.currentNavbarTitle }}
    v-btn.help-button.border-neutral500.button-Aa-small(outlined rounded @click="openUserback")
      .font-semibold.text-sm Need help?
</template>

<script>
export default {
  methods: {
    openUserback() {
      this.$userback.open()
    }
  }
}
</script>

<style scoped>
.help-button {
  padding: 6px 12px !important;
  border: 1px solid var(--v-neutral400) !important;
}
</style>